import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

declare module 'rxjs/Observable' {
    interface Observable<T> {
        whereLatest(condition: Observable<boolean>): Observable<T>;
        prioritize(): [Observable<T>, Observable<T>];
        extract(): T;
    }
}

(<any>Observable).prototype.whereLatest = function (o: Observable<any>) {
    return this.withLatestFrom(o, (x, y) => ({ value: x, filter: y })).filter(x => x.filter).map(x => x.value);
};

(<any>Observable).prototype.prioritize = function <T>() {
    const first = new Subject<T>();
    const second = this.do(x => first.next(x)).share();

    return [
        Observable.using(
            () => second.subscribe(() => { }),
            () => first
        ),
        second
    ];
};

(<any>Observable).prototype.extract = function () {
    let extracted = false;
    let value;
    this.first().subscribe(x => {
        value = x;
        extracted = true;
    }).unsubscribe();

    if (!extracted)
        throw new Error('extract() was unable to obtain a value from the provided observable!');

    return value;
}